import React, { useState, useEffect } from 'react'
import { Container } from '@sainsburys-tech/luna-react'

import BannerApi from '../../../api/bannerApi';
import { useApiClient } from '../../../context/AppContext';

import  {Banner}  from './../../../types/Entities/BannerType';

import FormAlerts from "../ContractorForm/FormAlerts";

const FMCoreBanner = () => {

    const apiClient = useApiClient();
    const [banner, setBanner] = useState([{}] as Banner[])
    const [errorAlert, setErrorAlert] = useState<false | string>(false);
    const [successAlert, setSuccessAlert] = useState<false | string>(false);

    useEffect(() => {
        fetchData()
        const interval = setInterval(() => {
            fetchData()
          }, 100000);
          return () => clearInterval(interval);
    },[])

    const fetchData = () => {
        return BannerApi.getBannerData(apiClient)
            .then(res => { return res})
            .then((res) => {
                if(res){
                    setBanner(res)
                    // setErrorAlert('something went wrong!')
                }
            })
            .catch((err) => {
                // setBanner([{id: '1' , notes : 'Something went wrong'}])
            })
    }

    const clearAlerts = () => {
        setErrorAlert(false);
        setSuccessAlert(false);
    };


    return(
        <>
        {/* <div className='content'> */}

            <FormAlerts
                showError={errorAlert}
                showSuccess={successAlert}
                onClose={clearAlerts}
            />
        {/* </div> */}
        {banner.length > 0 && (
            // <Container className='helpdesk-banner' fluid size='lg'>
                <div className="bg_color_white bdr_C_W_S risk-banner" style={{padding:'10px'}}>
                    {/* <ul> */}
                        {banner.map(x => (
                            <li>{x.notes}</li>
                        ))}
                    {/* </ul> */}
                </div>
            // </Container>
        )}
        </>
    )
}

export default FMCoreBanner